const HEADER_HEIGHT = '64px';

const layoutStyles = {
	content: `min-h-[calc(100dvh-${HEADER_HEIGHT})] flex flex-col bg-white text-neutral-low-dark antialiased`,
	checkoutContent: `min-h-[calc(100dvh-${HEADER_HEIGHT})] flex flex-col bg-[#FBFBFF] text-neutral-low-dark antialiased`
} as const;

export { layoutStyles };
